import request from 'utils/request'

import { MCBOS020InitRequest } from 'types/MCBOS020/MCBOS020InitRequest'
import { MCBOS020CreateRequest } from 'types/MCBOS020/MCBOS020CreateRequest'

export const initCheckApi = (param: MCBOS020InitRequest) =>
  request({
    url: '/MCBOS020/init',
    method: 'post',
    data: param,
})

export const doCreateApi = (param: MCBOS020CreateRequest) =>
  request({
    url: '/MCBOS020/register',
    method: 'post',
    data: param,
})